module.exports = __webpack_public_path__ + "images/bg-integral.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-integral.png
// module id = 834
// module chunks = 124